// @flow
export const ACTIONS = {
    NOTIFICATION_SETTINGS_LOADED: 'notification-settings-loaded',
    NOTIFICATION_SETTINGS_SET_EMAIL: 'notification-settings-set-email',
    NOTIFICATION_SETTINGS_SET_PUSH: 'notification-settings-set-push',
    NOTIFICATION_SETTINGS_SET_ALL_PUSH: 'notification-settings-set-all-push',
    NOTIFICATION_SETTINGS_SET_ALL_EMAIL: 'notification-settings-set-all-email',
    RESET_ALL: 'RESET_ALL'
};

export const NOTIFICATION_SETTINGS_CHANNELS = {
    EMAIL: 'email',
    PUSH: 'push'
};

export type NotificationSettingValue = {
    key: string,
    value: boolean
};

export type NotificationSetting = {
    title: string,
    push: NotificationSettingValue,
    email: NotificationSettingValue
};

export type NotificationSettingsLookup = {
    [key: string]: boolean
};
